/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// 'use strict'

expocadfx.overlays = function() {
	var Banner = expocadfx.adbanner;
	var config = expocadfx.config;
	var data = expocadfx.fxData;
	var FxEvent = expocadfx.fxevent;
	var numberPattern = /\d+/g;

	var doc = document;
	
	var overlayCount = 0;
	var banner = null;
	
	function saveOverlays( xml, jsonObject) {
        var overlays;
        var sponsors;
        var sponsorCount = 0;
        if( xml !== null) {
				// add overlays to floor plan
            overlays = xml.getElementsByTagName( "overlay");
            
            overlayCount = overlays.length;
            var i = 0;
            
            for( i = 0; i < overlayCount; i++) {
                
                data.arOverlays[i] = {
                    imgElement: null,
                    index: i,
                    source: overlays[i].getAttribute( "img"),
                    x: parseInt( overlays[i].getAttribute( "left"), 10) * config.MULTIPLIER,
                    y: parseInt( overlays[i].getAttribute( "top"), 10) * config.MULTIPLIER,
                    rot: overlays[i].getAttribute( "rot") * (Math.PI/180),
                    minX: 0,
                    minY: 0,
                    maxX: config.DRAWING_WIDTH,
                    maxY: config.DRAWING_HEIGHT,
                    path: [],
                    zoomTo: overlays[i].getAttribute( "boothNum"),
                    navTo: overlays[i].getAttribute( "url"),
                    toolTip: overlays[i].getAttribute( "tooltip"),
                    shadow: overlays[i].getAttribute( "shadow"),
					imageData: null,
                    ready: false
                };
                            
                data.arOverlays[i].imgElement = doc.createElement( "img");
                data.arOverlays[i].imgElement.setAttribute( "data-index", i);
                
                data.arOverlays[i].imgElement.src = data.arOverlays[i].source;

                if ( overlays[i].getAttribute("w") != undefined){
                    data.arOverlays[i].w = parseInt(overlays[i].getAttribute( "w").match(numberPattern));
                    data.arOverlays[i].h = parseInt(overlays[i].getAttribute( "h").match(numberPattern));

                    data.arOverlays[i].imgElement.addEventListener( "load", overlayLoaded);
                }
                else{
                    data.arOverlays[i].imgElement.addEventListener( "load", oldOverlayLoaded);
                }
                
                data.arOverlays[i].imgElement.addEventListener( "error", overlayError);
            }
            //  create ad banner ( but don't call it "ad" in html or css or AdBlocker will get you
            sponsors = xml.getElementsByTagName( "sponsor");  // would get header and footer
            
            if( sponsors && sponsors.length > 0) {
                sponsorCount = sponsors.length;
                banner = new Banner();
                
                for( i = 0; i < sponsorCount; i++) {

                    banner.arAds[i] = {
                        imgElement: null,
                        index: i,
                        width: 0,
                        source: sponsors[i].getAttribute( "img"),
                        zoomTo: sponsors[i].getAttribute( "boothNum"),
                        navTo: sponsors[i].getAttribute( "url"),
                        toolTip: sponsors[i].getAttribute( "tooltip"),
                        failed: false
                    };
                }
                banner.setAdInterval( xml.getElementsByTagName( "footerAds")[0].getAttribute( "interval"));
                data.hasSpns = true;
                banner.initAds();
                document.dispatchEvent( new expocadfx.fxevent( "Banner_Added", banner));
            }
        }

        if( jsonObject != null) {
            // add overlays to floor plan
        overlays = jsonObject.eventOverlays;
        
        overlayCount = overlays.length;
        var i = 0;
                    console.log(overlays)

        for( i = 0; i < overlayCount; i++) {
            data.arOverlays[i] = {
                imgElement: null,
                index: i,
                source: overlays[i].img,
                x: parseInt( overlays[i].left, 10) * config.MULTIPLIER,
                y: parseInt( overlays[i].top, 10) * config.MULTIPLIER,
                rot: overlays[i].rot * (Math.PI/180),
                w: parseInt(overlays[i].size.match(numberPattern)[0]),
                h: parseInt(overlays[i].size.match(numberPattern)[1]),
                minX: 0,
                minY: 0,
                maxX: config.DRAWING_WIDTH,
                maxY: config.DRAWING_HEIGHT,
                path: [],
                zoomTo: overlays[i].boothNum,
                navTo: overlays[i].url,
                toolTip: overlays[i].tooltip,
                shadow: overlays[i].shadow,
                imageData: null,
                ready: false
            };
            data.arOverlays[i].imgElement = doc.createElement( "img");
            data.arOverlays[i].imgElement.setAttribute( "data-index", i);
            
            data.arOverlays[i].imgElement.src = data.arOverlays[i].source;
            data.arOverlays[i].imgElement.addEventListener( "load", overlayLoaded);
            data.arOverlays[i].imgElement.addEventListener( "error", overlayError);
        }
        //  create ad banner ( but don't call it "ad" in html or css or AdBlocker will get you
        sponsors = jsonObject.sponsors;  // would get header and footer
        
        if( sponsors && sponsors.length > 0) {
            sponsorCount = sponsors.length;
            banner = new Banner();
            
            for( i = 0; i < sponsorCount; i++) {

                banner.arAds[i] = {
                    imgElement: null,
                    index: i,
                    width: 0,
                    source: sponsors[i].img,
                    zoomTo: sponsors[i].boothNum,
                    navTo: sponsors[i].url,
                    toolTip: sponsors[i].toolTip,
                    failed: false
                };
            }
            banner.setAdInterval( jsonObject.settings.interval);
            data.hasSpns = true;
            banner.initAds();
            document.dispatchEvent( new expocadfx.fxevent( "Banner_Added", banner));
        }
    }
	}

    function overlayError( evt) {
        evt.target.removeEventListener( "load", overlayLoaded);
        evt.target.removeEventListener( "error", overlayError);
        var index = evt.target.getAttribute( "data-index");
        var overlay = data.arOverlays[index];
        overlay.maxX = -1;
        overlay.maxY = -1;
        overlayCount -= 1;
        
        if( overlayCount === 0) {       /////  Need to force redraw
			data.status.overlaysReady = true;
            doc.dispatchEvent( new FxEvent( "Overlays_Loaded", null));
        }
    }
    
    function overlayLoaded( evt) {
        evt.target.removeEventListener( "load", overlayLoaded);
        evt.target.removeEventListener( "error", overlayError);
        
        var index = evt.target.getAttribute( "data-index");
        var overlay = data.arOverlays[index];
        //console.log(evt)
      //  if(xml === null || xml === undefined){  
       //     overlay.w = parseInt( overlay.w * 3.3) * config.MULTIPLIER;
        //    overlay.h = parseInt( overlay.h * 3.3) * config.MULTIPLIER;
   
            overlay.w = overlay.w * config.MULTIPLIER;
            overlay.h = overlay.h * config.MULTIPLIER;
        
        overlay.minX = overlay.x;
        overlay.maxX = overlay.x + overlay.w;
        overlay.minY = overlay.y;
        overlay.maxY = overlay.y + overlay.h;
        
        overlay.ready = true;
        overlayCount -= 1;
        
        if( overlayCount === 0) {       /////  Need to force redraw
			data.status.overlaysReady = true;
            doc.dispatchEvent( new FxEvent( "Overlays_Loaded", null));
        }
    }

    function oldOverlayLoaded( evt) {
        evt.target.removeEventListener( "load", oldOverlayLoaded);
        evt.target.removeEventListener( "error", overlayError);
        
        var index = evt.target.getAttribute( "data-index");
        var overlay = data.arOverlays[index];
        
        overlay.w = parseInt( evt.target.naturalWidth, 10) * config.MULTIPLIER;
        overlay.h = parseInt( evt.target.naturalHeight, 10) * config.MULTIPLIER;
        
        overlay.minX = overlay.x;
        overlay.maxX = overlay.x + overlay.w;
        overlay.minY = overlay.y;
        overlay.maxY = overlay.y + overlay.h;
        
        overlay.ready = true;
        overlayCount -= 1;
        
        if( overlayCount === 0) {       /////  Need to force redraw
			data.status.overlaysReady = true;
            doc.dispatchEvent( new FxEvent( "Overlays_Loaded", null));
        }
    }
	
	return {
		save: saveOverlays
	};
	
};